import { Fab, Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';
import RedesignImage from '../components/RedesignImage';
import { useIAChatFloatingButtonStyles } from './IAChatFloatingButton.styles';

const { colors, fonts, fontSize } = redesignTheme;

const CustomTooltip = withStyles({
  tooltip: {
    backgroundColor: colors.primary,
    color: colors.white,
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    borderRadius: 12,
    padding: '16px 20px',
    width: '221px !important',
    maxWidth: '221px !important',
    minWidth: '221px !important',
    boxSizing: 'border-box',
    textAlign: 'center',
    boxShadow: '0px 8px 24px rgba(14, 18, 71, 0.3)',
  },
  arrow: {
    color: colors.primary,
  },
})(Tooltip);

type IAChatFloatingButtonProps = {
  onClick: () => void;
};

const IAChatFloatingButton = ({ onClick }: IAChatFloatingButtonProps) => {
  const classes = useIAChatFloatingButtonStyles();

  return (
    <CustomTooltip
      title={
        <div className={classes.tooltipContent}>
          <div className={classes.tooltipTitle}>Parler à un coach IA</div>
          <div className={classes.tooltipSubtitle}>
            Je vous donne un éclairage personnalisé sur vos résultats
          </div>
        </div>
      }
      placement="top"
      arrow={true}>
      <Fab className={classes.fab} onClick={onClick} aria-label="Chat avec conseiller">
        <RedesignImage
          src="/static/media/circle-chatbot-conseiller.20bd122c.png"
          alt="Chat"
          className={classes.fabIcon}
        />
      </Fab>
    </CustomTooltip>
  );
};

export default IAChatFloatingButton;
